import { createContext, ReactNode, useContext, useMemo } from 'react'
import { CurrentUser } from 'customTypes'

interface SurveyContextValues {
  hideHeader?: boolean
  hideFooter?: boolean
  hideProgress?: boolean
  hideIntroScreen?: boolean
  navigateToNextStep?: (user?: CurrentUser | null) => Promise<void>
  registerCallback?: (callback: (() => boolean) | null) => void
}

const defaultValues: SurveyContextValues = {
  hideHeader: false,
  hideFooter: false,
  hideProgress: false,
  hideIntroScreen: false,
  registerCallback: () => {}
}

const SurveyContext = createContext(defaultValues)
export const useSurveyContext = () => useContext(SurveyContext)

interface SurveyProviderProps extends SurveyContextValues {
  children: ReactNode
}

export const SurveyProvider = ({
  children,
  hideHeader,
  hideFooter,
  hideProgress,
  hideIntroScreen,
  navigateToNextStep,
  registerCallback
}: SurveyProviderProps) => {
  const value = useMemo(
    () => ({
      hideHeader: hideHeader ?? defaultValues.hideHeader,
      hideFooter: hideFooter ?? defaultValues.hideFooter,
      hideProgress: hideProgress ?? defaultValues.hideProgress,
      hideIntroScreen: hideIntroScreen ?? defaultValues.hideIntroScreen,
      navigateToNextStep,
      registerCallback: registerCallback ?? defaultValues.registerCallback
    }),
    [hideHeader, hideFooter, hideProgress, hideIntroScreen, navigateToNextStep, registerCallback]
  )

  return <SurveyContext.Provider value={value}>{children}</SurveyContext.Provider>
}
